import React, { useEffect, useState } from 'react';
import { apiKeyService } from '../../lib/apiKeyService';
import { supabase } from '../../lib/supabase';
import AdminLayout from '../../components/admin/AdminLayoutOptimized';

interface ApiKey {
  id: string;
  service: string;
  api_key: string;
  created_at: string;
  updated_at: string;
  metadata?: Record<string, any>;
}

const TestApiPage: React.FC = () => {
  const [keys, setKeys] = useState<ApiKey[]>([]);
  const [directKeys, setDirectKeys] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Méthode 1: Via le service
        const allKeys = await apiKeyService.getAllApiKeys();
        setKeys(allKeys);

        // Méthode 2: Appel direct à Supabase
        const { data, error } = await supabase
          .from('api_keys')
          .select('*');
        
        if (error) {
          throw error;
        }

        setDirectKeys(data || []);
      } catch (err: any) {
        console.error('Erreur lors de la récupération des clés API:', err);
        setError(err.message || 'Erreur inconnue');
      }
    };

    fetchData();
  }, []);

  return (
    <AdminLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold mb-6">Test API - Récupération des clés</h1>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <p className="font-bold">Erreur:</p>
            <p>{error}</p>
          </div>
        )}
        
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h2 className="text-xl font-semibold mb-4">Via apiKeyService</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
              {JSON.stringify(keys, null, 2)}
            </pre>
          </div>
          
          <div>
            <h2 className="text-xl font-semibold mb-4">Via Supabase direct</h2>
            <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
              {JSON.stringify(directKeys, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default TestApiPage;
